var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero'),_c('Feature'),_c('Service'),_c('Statistics'),_c('Review'),_c('Warranty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }